//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import { SxProps, Theme } from '@mui/material/styles';

// Common colors for license display component
export const licenseColor = {
  disabledColor: 'rgba(0, 0, 0, 0.38)',
  disabledColorDark: 'rgba(255, 255, 255, 0.38)',
  regularTextColor: 'rgba(0, 0, 0, 0.87)',
  regularTextColorDark: 'rgba(255, 255, 255, 0.87)',
  tierCountColor: '#FF9900',
  iconColor: '#0078d4',
  labelColor: '#333',
  labelColorDark: '#c8c8dd',
  dividerColor: '#ccc',
  dividerColorDark: '#525252',
};

// Styles for license display component
export const licenseDisplayStyles = (darkMode = false) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    whiteSpace: 'nowrap',
    width: '100%',
    height: '32px',
    padding: '0 8px',
  } as SxProps<Theme>,

  // Icon section styles
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '8px',
  } as SxProps<Theme>,

  icon: {
    fontSize: '16px',
    color: licenseColor.iconColor,
    marginRight: '4px',
    width: '16px',
    height: '16px',
  } as SxProps<Theme>,

  labelText: {
    fontWeight: 500,
    fontSize: '13px',
    color: darkMode ? licenseColor.labelColorDark : licenseColor.labelColor,
  } as SxProps<Theme>,

  // Tiers section styles
  tiersContainer: (theme: Theme) =>
    ({
      display: 'flex',
      flexDirection: 'row',
      gap: 0,
      flexWrap: 'nowrap',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        gap: '8px',
      },
    }) as SxProps<Theme>,

  tierItem: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    height: '100%',
    padding: '0 8px',
  } as SxProps<Theme>,

  tierDivider: {
    position: 'absolute',
    left: 0,
    height: '16px',
    borderRight: `1px solid ${darkMode ? licenseColor.dividerColorDark : licenseColor.dividerColor}`,
  } as SxProps<Theme>,

  tierIndicator: {
    width: '3px',
    height: '16px',
    borderRadius: '0%',
    marginRight: '8px',
    flexShrink: 0,
  } as SxProps<Theme>,

  tierText: {
    whiteSpace: 'nowrap',
    fontSize: '13px',
    fontWeight: 400,
  } as SxProps<Theme>,

  tierCount: {
    color: licenseColor.tierCountColor,
    fontWeight: 500,
  } as SxProps<Theme>,

  disabledTier: {
    opacity: 0.5,
  } as SxProps<Theme>,

  tierTextDefault: {
    color: darkMode
      ? licenseColor.regularTextColorDark
      : licenseColor.regularTextColor,
  } as SxProps<Theme>,

  tierTextDisabled: {
    color: darkMode
      ? licenseColor.disabledColorDark
      : licenseColor.disabledColor,
  } as SxProps<Theme>,

  selectedTier: {
    fontWeight: 500,
  } as SxProps<Theme>,
});
